import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export { createCitrixLocaleInterceptor } from './citrixlocaleInterceptor';
export { CITRIX_TRANSACTIONID_HEADER } from './headers';
export { tryExtractTransactionId } from './tryExtractTransactionId';
import axios, { AxiosHeaders } from 'axios';
var clientInstance;
function singleton() {
  if (!clientInstance) {
    clientInstance = createClient();
  }
  return clientInstance;
}
var isAxiosHeaders = function isAxiosHeaders(input) {
  return input['hasUserAgent'] !== undefined;
};
var makeHeadersSane = function makeHeadersSane(headers) {
  return isAxiosHeaders(headers) ? headers : new AxiosHeaders(headers);
};
var makeRequestAxiosSane = function makeRequestAxiosSane(req) {
  if (!(req !== null && req !== void 0 && req.headers)) {
    return req;
  }
  return _objectSpread(_objectSpread({}, req), {}, {
    headers: makeHeadersSane(req.headers)
  });
};
export function createClient(defaults) {
  return new Client(makeRequestAxiosSane(defaults));
}
var Client = /*#__PURE__*/function () {
  function Client(_defaults) {
    var _this = this;
    _classCallCheck(this, Client);
    this._defaults = _defaults;
    _defineProperty(this, "_clientInstance", void 0);
    _defineProperty(this, "get", function (url, requestConfig) {
      return _this.clientInstance().get(url, makeRequestAxiosSane(requestConfig)).then(function (_ref) {
        var data = _ref.data;
        return data;
      })["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
    _defineProperty(this, "post", function (url, requestData, requestConfig) {
      return _this.clientInstance().post(url, requestData, makeRequestAxiosSane(requestConfig)).then(function (_ref2) {
        var data = _ref2.data;
        return data;
      })["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
    _defineProperty(this, "addResponseInterceptor", function (_ref3) {
      var onFulfilled = _ref3.onFulfilled,
        onRejected = _ref3.onRejected;
      var id = _this.clientInstance().interceptors.response.use(onFulfilled, onRejected);
      return function () {
        return _this.clientInstance().interceptors.response.eject(id);
      };
    });
    _defineProperty(this, "getWithFullResponse", function (url, requestConfig) {
      return _this.clientInstance().get(url, makeRequestAxiosSane(requestConfig))["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
    _defineProperty(this, "addRequestInterceptor", function (_ref4) {
      var prepareRequest = _ref4.prepareRequest,
        onError = _ref4.onError;
      var id = _this.clientInstance().interceptors.request.use(prepareRequest, onError);
      return function () {
        return _this.clientInstance().interceptors.request.eject(id);
      };
    });
    _defineProperty(this, "postAsFormData", function (url) {
      var requestData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var requestConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var config = _objectSpread(_objectSpread({}, requestConfig), {}, {
        headers: new AxiosHeaders(_objectSpread(_objectSpread({}, requestConfig.headers), {}, {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }))
      });
      var params = objectToParams(requestData);
      return _this.clientInstance().post(url, params, config).then(function (_ref5) {
        var data = _ref5.data;
        return data;
      })["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
    _defineProperty(this, "postWithFullResponse", function (url, requestData, requestConfig) {
      return _this.clientInstance().post(url, requestData, makeRequestAxiosSane(requestConfig))["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
    _defineProperty(this, "delete", function (url, requestConfig) {
      return _this.clientInstance()["delete"](url, makeRequestAxiosSane(requestConfig)).then(function (_ref6) {
        var data = _ref6.data;
        return data;
      })["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
    _defineProperty(this, "deleteWithFullResponse", function (url, requestConfig) {
      return _this.clientInstance()["delete"](url, makeRequestAxiosSane(requestConfig))["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
    _defineProperty(this, "put", function (url, requestData, requestConfig) {
      return _this.clientInstance().put(url, requestData, makeRequestAxiosSane(requestConfig)).then(function (_ref7) {
        var data = _ref7.data;
        return data;
      })["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
    _defineProperty(this, "putWithFullResponse", function (url, requestData, requestConfig) {
      return _this.clientInstance().put(url, requestData, makeRequestAxiosSane(requestConfig))["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
    _defineProperty(this, "patch", function (url, requestData, requestConfig) {
      return _this.clientInstance().patch(url, requestData, makeRequestAxiosSane(requestConfig)).then(function (_ref8) {
        var data = _ref8.data;
        return data;
      })["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
    _defineProperty(this, "patchWithFullResponse", function (url, requestData, requestConfig) {
      return _this.clientInstance().patch(url, requestData, makeRequestAxiosSane(requestConfig))["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
    _defineProperty(this, "request", function (config) {
      return _this.clientInstance().request(makeRequestAxiosSane(config)).then(function (_ref9) {
        var data = _ref9.data;
        return data;
      })["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
    _defineProperty(this, "requestWithFullResponse", function (config) {
      return _this.clientInstance().request(makeRequestAxiosSane(config))["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
    _defineProperty(this, "head", function (url, requestConfig) {
      return _this.clientInstance().head(url, makeRequestAxiosSane(requestConfig))["catch"](function (err) {
        return handleFailedRequest(err);
      });
    });
  }
  return _createClass(Client, [{
    key: "clientInstance",
    value: function clientInstance() {
      if (!this._clientInstance) {
        this._clientInstance = axios.create(this._defaults);
      }
      return this._clientInstance;
    }
  }]);
}();
export var get = function get() {
  var _singleton;
  return (_singleton = singleton()).get.apply(_singleton, arguments);
};
export var addResponseInterceptor = function addResponseInterceptor() {
  var _singleton2;
  return (_singleton2 = singleton()).addResponseInterceptor.apply(_singleton2, arguments);
};
export var getWithFullResponse = function getWithFullResponse() {
  var _singleton3;
  return (_singleton3 = singleton()).getWithFullResponse.apply(_singleton3, arguments);
};
export var addRequestInterceptor = function addRequestInterceptor() {
  var _singleton4;
  return (_singleton4 = singleton()).addRequestInterceptor.apply(_singleton4, arguments);
};
export var post = function post() {
  var _singleton5;
  return (_singleton5 = singleton()).post.apply(_singleton5, arguments);
};
export var postAsFormData = function postAsFormData() {
  var _singleton6;
  return (_singleton6 = singleton()).postAsFormData.apply(_singleton6, arguments);
};
export var postWithFullResponse = function postWithFullResponse() {
  var _singleton7;
  return (_singleton7 = singleton()).postWithFullResponse.apply(_singleton7, arguments);
};
export var _delete = function _delete() {
  var _singleton8;
  return (_singleton8 = singleton())["delete"].apply(_singleton8, arguments);
};
export var put = function put() {
  var _singleton9;
  return (_singleton9 = singleton()).put.apply(_singleton9, arguments);
};
export var putWithFullResponse = function putWithFullResponse() {
  var _singleton10;
  return (_singleton10 = singleton()).putWithFullResponse.apply(_singleton10, arguments);
};
export var patch = function patch() {
  var _singleton11;
  return (_singleton11 = singleton()).patch.apply(_singleton11, arguments);
};
export var patchWithFullResponse = function patchWithFullResponse() {
  var _singleton12;
  return (_singleton12 = singleton()).patchWithFullResponse.apply(_singleton12, arguments);
};
export var request = function request() {
  var _singleton13;
  return (_singleton13 = singleton()).request.apply(_singleton13, arguments);
};
export var requestWithFullResponse = function requestWithFullResponse() {
  var _singleton14;
  return (_singleton14 = singleton()).requestWithFullResponse.apply(_singleton14, arguments);
};
export var head = function head() {
  var _singleton15;
  return (_singleton15 = singleton()).head.apply(_singleton15, arguments);
};
export function handleFailedRequest(error) {
  var code = error.code;
  // https://github.com/axios/axios/issues/1543
  if (error.code === 'ECONNABORTED') {
    if (error.message.includes('timeout')) {
      code = 'timeout';
    } else {
      code = 'aborted';
    }
  }
  if (!error.response) {
    var aborted = {
      responseJSON: error.message,
      responseText: error.message,
      status: null,
      code: code,
      headers: {},
      error: error
    };
    return Promise.reject(aborted);
  }
  var failedResponse = {
    responseJSON: error.response.data,
    responseText: JSON.stringify(error.response.data),
    status: error.response.status,
    code: code,
    headers: error.response.headers,
    error: error
  };
  return Promise.reject(failedResponse);
}
export function isFailedResponse(object) {
  var requiredFailedResponseKeys = ['headers', 'responseJSON', 'responseText', 'status', 'error'];
  return !!object && _typeof(object) === 'object' && requiredFailedResponseKeys.every(function (key) {
    return object.hasOwnProperty(key);
  });
}
function objectToParams() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(obj).reduce(function (params, key) {
    var val = obj[key];
    var param = !!val && val.toString() === '[object Object]' ? objectToParams(val) : "".concat(key, "=").concat(encodeURIComponent(obj[key]));
    return [].concat(_toConsumableArray(params), [param]);
  }, []).filter(function (v) {
    return !!v;
  }).join('&');
}